/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTaxStandardDto } from '../../models/backend-tax-standard-dto';
import { BackendTaxStandardRequestDto } from '../../models/backend-tax-standard-request-dto';

export interface ProjectTaxesTaxStandardUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body: BackendTaxStandardRequestDto;
}

export function projectTaxesTaxStandardUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxStandardUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxStandardUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxStandardDto>;
    }),
  );
}

projectTaxesTaxStandardUpdate$XWwwFormUrlencoded.PATH = '/api/project_taxes/tax_standard/{id}/';
